import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const P = ({ children, className, small }) =>
  <p className={classNames('P', { 'P--small': small }, className)}>
    {children}
  </p>;

P.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  small: PropTypes.bool,
};

P.defaultProps = {
  className: null,
  small: false,
};

export default P;



// WEBPACK FOOTER //
// ./src/components/P/index.js